export default {
  list: {
    name: "special share parties list api",
    version: 6,
    url: "special-share-parties",
    method: "GET",
  },
  create: {
    name: "special share party create api",
    version: 6,
    url: "special-share-parties",
    method: "POST",
  },
  update: {
    name: "special share party update api",
    version: 6,
    url: "special-share-parties/%{id}",
    method: "PUT",
  },
  delete: {
    name: "special share party delete api",
    version: 6,
    url: "special-share-parties/%{id}",
    method: "DELETE",
  },
};
